import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * HubSpot tracking script - only loads on public website pages
 * Excludes: /portal, /admin, /partner, /login paths
 */
const HubSpotScript = () => {
  const location = useLocation();

  useEffect(() => {
    // List of paths where HubSpot should NOT load
    const excludedPaths = ["/portal", "/admin", "/partner", "/login"];
    
    // Check if current path starts with any excluded path
    const isExcludedPage = excludedPaths.some(path => 
      location.pathname.startsWith(path)
    );

    // Only load HubSpot on public pages
    if (!isExcludedPage) {
      // Check if script already exists
      const existingScript = document.getElementById("hs-script-loader");
      
      if (!existingScript) {
        const script = document.createElement("script");
        script.id = "hs-script-loader";
        script.type = "text/javascript";
        script.async = true;
        script.defer = true;
        script.src = "//js-na2.hs-scripts.com/245037137.js";
        document.body.appendChild(script);
      }
    }

    // Cleanup: remove script when navigating to excluded pages
    return () => {
      const isNowExcluded = excludedPaths.some(path => 
        location.pathname.startsWith(path)
      );
      
      if (isNowExcluded) {
        const script = document.getElementById("hs-script-loader");
        if (script) {
          script.remove();
        }
        // Also remove HubSpot chat widget if present
        const hubspotWidget = document.getElementById("hubspot-messages-iframe-container");
        if (hubspotWidget) {
          hubspotWidget.remove();
        }
      }
    };
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default HubSpotScript;
